import { OnsiteTriggers, TriggersConfigMap, TriggerType } from 'sections/onsite-campaigns/types';

export function mapStateToTriggers(triggers?: TriggersConfigMap): OnsiteTriggers {
  const onsiteTriggers = {} as OnsiteTriggers;

  if (triggers?.[TriggerType.ExitIntent]?.active && triggers?.[TriggerType.ExitIntent]?.value) {
    onsiteTriggers.exitFrame = triggers[TriggerType.ExitIntent].value;
  }

  if (triggers?.[TriggerType.Inactivity]?.active && triggers?.[TriggerType.Inactivity]?.value) {
    onsiteTriggers.inactivity = triggers[TriggerType.Inactivity].value * 1000;
  }

  if (triggers?.[TriggerType.PageLoad]?.active) {
    onsiteTriggers.onLoad = true;
  }

  if (triggers?.[TriggerType.OnClick]?.active && triggers?.[TriggerType.OnClick]?.value?.selector) {
    onsiteTriggers.onClick = triggers[TriggerType.OnClick].value;
  }

  return onsiteTriggers;
}
